__turbopack_context__.v({
  "appDownloadButton": "styles-module__R8g1vW__appDownloadButton",
  "footer": "styles-module__R8g1vW__footer",
});
